import { render, staticRenderFns } from "./BenefitGroupList.vue?vue&type=template&id=6a5c2ca0&"
import script from "./BenefitGroupList.vue?vue&type=script&lang=js&"
export * from "./BenefitGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports